module.exports = "pegasus_template/assets/themecapture1/ebook/100.png";